// src/components/Admin/organizations/OrgsTable.tsx
import React from 'react';
import { OrganizationItem } from '../../../api/adminOrganizationsService';
import { useTranslation } from 'react-i18next';

interface Props {
  items: OrganizationItem[];
  selectedId: string | null;
  onSelect: (it: OrganizationItem) => void;
}

/* ─── color por nivel de riesgo ─── */
const rowColor = (risk: number) => {
  if (risk < 40) return 'bg-green-50 hover:bg-green-100 text-green-800';
  if (risk < 70) return 'bg-yellow-50 hover:bg-yellow-100 text-yellow-900';
  return           'bg-red-50 hover:bg-red-100 text-red-800';
};

const OrgsTable: React.FC<Props> = ({ items, selectedId, onSelect }) => {
  const { t } = useTranslation();

  return (
    <div className="h-[70vh] overflow-y-auto rounded-xl shadow ring-1 ring-gray-200 bg-white">
      <table className="min-w-full text-sm">
        <thead className="sticky top-0 bg-gray-100 text-gray-700 text-xs uppercase">
          <tr>
            <th className="px-4 py-3 text-left">{t('admin.company')}</th>
            <th className="px-4 py-3 text-center">{t('admin.breaches')}</th>
            <th className="px-4 py-3 text-center">{t('admin.vulns')}</th>
            <th className="px-4 py-3 text-center">{t('admin.risk')}</th>
          </tr>
        </thead>

        <tbody>
          {items.map((it) => {
            const isSelected = it.org.id === selectedId;
            const color      = rowColor(it.report.risk);

            return (
              <tr
                key={it.org.id}
                onClick={() => onSelect(it)}
                className={`
                  cursor-pointer
                  ${isSelected
                    ? 'bg-blue-50 ring-2 ring-inset ring-blue-400 border-l-4 border-blue-600 text-slate-800'
                    : color}
                `}
              >
                <td className="px-4 py-2 font-medium">{it.org.name}</td>
                <td className="px-4 py-2 text-center">
                  {it.report.len_data_breaches}
                </td>
                <td className="px-4 py-2 text-center">
                  {it.report.len_vulns}
                </td>
                <td className="px-4 py-2 text-center font-semibold">
                  {it.report.risk.toFixed(0)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default OrgsTable;
